import axios from "axios";
import GraphContent from "../graph_content";
import moment from "moment";
import { RequestParamsMaker } from "./make_request_params";
import { Threshold } from "@/types/types";

export class AlertChecker {
  public static async checkAlert(self: GraphContent) {
    const promises: Array<Promise<any>> = [];

    Object.keys(self.thresholdSettings).forEach((key: string) => {
      const threshold: Threshold = self.thresholdSettings[key];
      self.attributeValueColors[key] = "#32c201";
      if (threshold.max.enabled) {
        promises.push(AlertChecker.checkOver(self, key, threshold));
      }
      if (threshold.min.enabled) {
        promises.push(AlertChecker.checkUnder(self, key, threshold));
      }
    });
    try {
      await Promise.all(promises);
    } catch (err) {
      console.error(err);
    }
  }

  public static checkSendTime(self: GraphContent, key: string) {
    const nowTime: string = moment().format();
    const lastSendTime: string = self.lastSendTimes[key];
    if (lastSendTime === undefined) {
      self.lastSendTimes[key] = nowTime;
      return true;
    }
    const checkTime: string = moment(lastSendTime)
      .add(1, "h")
      .format();
    if (nowTime >= checkTime) {
      self.lastSendTimes[key] = nowTime;
      return true;
    } else {
      return false;
    }
  }

  private static setDisplay(self: GraphContent) {
    self.displayUnconfirmedAlert = Object.assign([], self.unconfirmedAlert);
    self.displayUnconfirmedAlert.reverse();
  }

  private static filterAlerts(
    alertHistory: GraphContent["alertHistory"],
    item: { [key: string]: any }
  ) {
    return alertHistory.filter(function(alert) {
      return !(alert.attribute === item.attribute && alert.date === item.date);
    });
  }

  private static readCheck(self: GraphContent, item: { [key: string]: any }) {
    self.alertHistory.forEach(
      (alert: { [key: string]: any }, index: number) => {
        if (alert.date === item.date) {
          self.unconfirmedAlert.pop();
        }
      }
    );
  }

  private static sendAlert(self: GraphContent) {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const changeAlertSwitch = self.changeAlertSwitch
        if (changeAlertSwitch === true) {
          return;
        }
        const userID = self.userID;
        const requestParams = RequestParamsMaker.makeSendAlertParams(
          self,
          userID
        );
        await axios(requestParams);
        return resolve();
      } catch (err) {
        console.log(err)
        return reject(err);
      }
    });
  }

  private static async checkOver(
    self: GraphContent,
    key: string,
    baseThreshold: Threshold
  ) {
    if (baseThreshold.max.value <= Number(self.latestAttributeValues[key])) {
      self.attributeValueColors[key] = "rgba(255, 10, 10, 1)";
      const item = {
        sensorData: self.latestAttributeValues[key],
        tableName: self.tableName,
        attribute: key,
        partition: self.targetPartitionKey,
        date: self.latestDataDate,
        type: "over"
      };
      const beforeLen = self.unconfirmedAlert.length;
      self.alertHistory = AlertChecker.filterAlerts(self.alertHistory, item);
      self.unconfirmedAlert = AlertChecker.filterAlerts(
        self.unconfirmedAlert,
        item
      );
      self.unconfirmedAlert.push(item);
      AlertChecker.readCheck(self, item);
      AlertChecker.checkAlertLength(self);
      if (beforeLen !== self.unconfirmedAlert.length) {
        if (AlertChecker.checkSendTime(self, key) && self.mails.length > 0) {
          await AlertChecker.sendAlert(self);
        }
        AlertChecker.setDisplay(self);
      }
    }
  }

  private static async checkUnder(
    self: GraphContent,
    key: string,
    baseThreshold: Threshold
  ) {
    if (baseThreshold.min.value >= Number(self.latestAttributeValues[key])) {
      self.attributeValueColors[key] = "rgba(10, 10, 255, 1)";
      const item = {
        sensorData: self.latestAttributeValues[key],
        tableName: self.tableName,
        attribute: key,
        partition: self.targetPartitionKey,
        date: self.latestDataDate,
        type: "under"
      };
      const beforeLen = self.unconfirmedAlert.length;
      self.alertHistory = AlertChecker.filterAlerts(self.alertHistory, item);
      self.unconfirmedAlert = AlertChecker.filterAlerts(
        self.unconfirmedAlert,
        item
      );
      self.unconfirmedAlert.push(item);
      AlertChecker.readCheck(self, item);
      AlertChecker.checkAlertLength(self);
      if (beforeLen !== self.unconfirmedAlert.length) {
        if (AlertChecker.checkSendTime(self, key) && self.mails.length > 0) {
          await AlertChecker.sendAlert(self);
        }
        AlertChecker.setDisplay(self);
      }
    }
  }

  private static checkAlertLength(self: GraphContent) {
    if (self.alertHistory.length > 100) {
      self.alertHistory.shift();
      AlertChecker.checkAlertLength(self);
    }
  }
}
